// src/pages/Profile/ui/ProfileField.jsx

import React from "react";

export default function ProfileField({
  label,
  name,
  value,
  onChange,
  autoComplete,
}) {
  return (
    <div>
      <label className="mb-2 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <input
        type="text"
        name={name}
        value={value || ""}
        onChange={onChange}
        autoComplete={autoComplete}
        className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-primary focus:ring-4 focus:ring-primary/10 dark:border-white/10 dark:bg-slate-950/70 dark:text-white"
      />
    </div>
  );
}